import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/css/header.css";
import cloudLogo from "../assets/images/cloud-mind-logo.webp";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setOpenDropdown(null);
  };

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  return (
    <header className={`modern-header ${isScrolled ? "header-scrolled" : ""}`}>
      <div className="header-container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="header-logo">
            <img src={cloudLogo} alt="Cloud Mind X" className="logo-image" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            <ul className="nav-menu">
              <li className="nav-item">
                <Link to="/" className="nav-link">HOME</Link>
              </li>

              <li className="nav-item">
                <Link to="/about" className="nav-link">ABOUT</Link>
              </li>

              <li className="nav-item dropdown-item">
                <span className="nav-link">
                  SERVICES
                  <svg className="dropdown-icon" width="10" height="6" viewBox="0 0 10 6" fill="none">
                    <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <div className="dropdown-menu dropdown-menu-grid">
                  <div className="dropdown-column">
                    <Link to="/services/ai-services" className="dropdown-link">AI Services</Link>
                    <Link to="/services/app-development" className="dropdown-link">App Development</Link>
                    <Link to="/services/website-development" className="dropdown-link">Website Development</Link>
                    <Link to="/services/digital-marketing" className="dropdown-link">Digital Marketing</Link>
                  </div>
                  <div className="dropdown-column">
                    <Link to="/services/cyber-security" className="dropdown-link">Cyber Security</Link>
                    <Link to="/services/cloud-services" className="dropdown-link">Cloud Services</Link>
                    <Link to="/services/it-consulting" className="dropdown-link">IT Consulting</Link>
                    <Link to="/services/data-center" className="dropdown-link">Data Center</Link>
                  </div>
                </div>
              </li>

              {/* <li className="nav-item">
                <Link to="/difference" className="nav-link">DIFFERENCE</Link>
              </li> */}

              <li className="nav-item dropdown-item">
                <span className="nav-link">
                  RESOURCES
                  <svg className="dropdown-icon" width="10" height="6" viewBox="0 0 10 6" fill="none">
                    <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <div className="dropdown-menu">
                  <Link to="/blog" className="dropdown-link">Blog</Link>
                  <Link to="/resources/case-studies" className="dropdown-link">Case Studies</Link>
                  <Link to="/industries" className="dropdown-link">Industries</Link>
                  <Link to="/career" className="dropdown-link">Career</Link>
                </div>
              </li>

              <li className="nav-item">
                <Link to="/contact" className="nav-link nav-link-cta">Get in Touch</Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Toggle */}
          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <ul className="mobile-menu">
            <li className="mobile-nav-item">
              <Link to="/" className="mobile-nav-link" onClick={toggleMobileMenu}>HOME</Link>
            </li>

            <li className="mobile-nav-item">
              <Link to="/about" className="mobile-nav-link" onClick={toggleMobileMenu}>ABOUT</Link>
            </li>

            <li className="mobile-nav-item">
              <button
                className="mobile-nav-link"
                onClick={() => toggleDropdown('services')}
              >
                SERVICES
                <svg className={`dropdown-icon ${openDropdown === 'services' ? 'rotated' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none">
                  <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className={`mobile-dropdown ${openDropdown === 'services' ? 'open' : ''}`} style={{ textAlign: 'left' }}>
                <Link to="/services/ai-services" className="mobile-dropdown-link" onClick={toggleMobileMenu}>AI Services</Link>
                <Link to="/services/app-development" className="mobile-dropdown-link" onClick={toggleMobileMenu}>App Development</Link>
                <Link to="/services/website-development" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Website Development</Link>
                <Link to="/services/digital-marketing" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Digital Marketing</Link>
                <Link to="/services/cyber-security" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Cyber Security</Link>
                <Link to="/services/cloud-services" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Cloud Services</Link>
                <Link to="/services/it-consulting" className="mobile-dropdown-link" onClick={toggleMobileMenu}>IT Consulting</Link>
                <Link to="/services/data-center" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Data Center</Link>
              </div>
            </li>

            {/* <li className="mobile-nav-item">
              <Link to="/difference" className="mobile-nav-link" onClick={toggleMobileMenu}>DIFFERENCE</Link>
            </li> */}

            <li className="mobile-nav-item">
              <button
                className="mobile-nav-link"
                onClick={() => toggleDropdown('resources')}
              >
                RESOURCES
                <svg className={`dropdown-icon ${openDropdown === 'resources' ? 'rotated' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none">
                  <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className={`mobile-dropdown ${openDropdown === 'resources' ? 'open' : ''}`} style={{ textAlign: 'left' }}>
                <Link to="/resources/blog" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Blog</Link>
                <Link to="/resources/case-studies" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Case Studies</Link>
                <Link to="/industries" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Industries</Link>
                <Link to="/career" className="mobile-dropdown-link" onClick={toggleMobileMenu}>Career</Link>
              </div>
            </li>

            <li className="mobile-nav-item">
              <Link to="/contact" className="mobile-nav-link mobile-nav-link-cta" onClick={toggleMobileMenu}>Get in Touch</Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
